import { supabase } from '../supabase';
import { useQuery, useMutation } from '@tanstack/react-query';

export interface PayForm {
  id: string;
  form_link: string;
  created_at: string;
  updated_at: string;
}

export const SupabasePayFormService = {
  async getPayForm(): Promise<PayForm | null> {
    const { data: form, error } = await supabase
      .from('pay_form')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle();

    if (error || !form) return null;
    return form;
  },

  async cyclePayForm(title: string): Promise<{
    success: boolean;
    formId?: string;
    formUrl?: string;
    message: string
  }> {
    const { data, error } = await supabase.functions.invoke('pay-form-cycle', {
      body: { title }
    });

    if (error) throw error;
    return data;
  },
};

export const usePayForm = () => {
  return useQuery({
    queryKey: ['pay_form'],
    queryFn: () => SupabasePayFormService.getPayForm()
  });
};

export const useCyclePayForm = () => {
  return useMutation({
    mutationFn: (title: string) => SupabasePayFormService.cyclePayForm(title)
  });
};

export default SupabasePayFormService;